module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"DOCUMENTS":"Documents","ATTACHEMENT":"Attachement","DOWNLOADFILE":"Download File","NOLABEL":"No Label"},"ar":{"DOCUMENTS":"مستندات","ATTACHEMENT":"المرفق","DOWNLOADFILE":"تحميل الملف","NOLABEL":"لا ملصق"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/dialogs/Doc.vue
// module id = 307
// module chunks = 1